import { render, staticRenderFns } from "./ParcelPreviousDocumentsSection.vue?vue&type=template&id=99f1005a&scoped=true&"
import script from "./ParcelPreviousDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelPreviousDocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelPreviousDocumentsSection.vue?vue&type=style&index=0&id=99f1005a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f1005a",
  null
  
)

export default component.exports